"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _Notifications = require("../../../../Notifications"),
    _requestAccess = require("../api/requestAccess"),
    _genericError = require("../../../constants/genericError");

require("../styles/_request-access.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var RequestAccess = function (_Component) {
  function RequestAccess() {
    var _this;

    return (0, _classCallCheck2["default"])(this, RequestAccess), _this = _super.call(this), _this.handleRequestAccess = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var _this$props, apiClient, ownerId, _yield$apiClient$quer, _yield$apiClient$quer2, errors;

      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return _this$props = _this.props, apiClient = _this$props.apiClient, ownerId = _this$props.ownerId, _this.setState({
                requesting: !0
              }), _context.prev = 2, _context.next = 5, apiClient.query({
                query: _requestAccess.requestAccessQuery,
                context: {
                  module: "users"
                },
                variables: {
                  input: {
                    ownerId: ownerId,
                    url: window.location.href
                  }
                }
              });

            case 5:
              if (_yield$apiClient$quer = _context.sent, _yield$apiClient$quer2 = _yield$apiClient$quer.errors, errors = void 0 === _yield$apiClient$quer2 ? [] : _yield$apiClient$quer2, !errors.length) {
                _context.next = 11;
                break;
              }

              return (0, _Notifications.notify)({
                type: "error",
                content: _genericError.GENERIC_ERROR_MSG
              }), _context.abrupt("return", void _this.setState({
                requesting: !1
              }));

            case 11:
              _this.setState({
                requested: !0,
                requesting: !1
              }), _context.next = 18;
              break;

            case 14:
              _context.prev = 14, _context.t0 = _context["catch"](2), (0, _Notifications.notify)({
                type: "error",
                content: _genericError.GENERIC_ERROR_MSG
              }), _this.setState({
                requesting: !1
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 14]]);
    })), _this.state = {
      requesting: !1,
      requested: !1
    }, _this;
  }

  (0, _inherits2["default"])(RequestAccess, _Component);

  var _super = _createSuper(RequestAccess);

  return (0, _createClass2["default"])(RequestAccess, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          requesting = _this$state.requesting,
          requested = _this$state.requested;
      return _react["default"].createElement("div", {
        className: "request-access"
      }, _react["default"].createElement("div", {
        className: "request-access__inner"
      }, _react["default"].createElement(_uiKit.Icon, {
        className: "request-access__icon",
        name: "padlock",
        color: "regent"
      }), _react["default"].createElement("div", {
        className: "request-access__text"
      }, _react["default"].createElement("p", {
        className: "request-access__header"
      }, "Hmm.. you don't seem to have access to this page."), _react["default"].createElement("p", {
        className: "request-access__suggest"
      }, "You can request access from the page owner"), _react["default"].createElement(_uiKit.Button, {
        busy: requesting,
        onClick: this.handleRequestAccess,
        disabled: requested
      }, requested ? _react["default"].createElement("div", {
        className: "request-access__requested"
      }, _react["default"].createElement(_uiKit.Icon, {
        name: "success",
        color: "white",
        size: 20
      }), "Access Requested") : "Request Access"))), _react["default"].createElement("p", {
        className: "request-access__assist"
      }, "If the problem persists, contact your dedicated Account Manager or visit our", " ", _react["default"].createElement(_uiKit.LinkButton, null, "Help Center"), " ", "for more information."));
    }
  }]), RequestAccess;
}(_react.Component);

exports["default"] = RequestAccess;